export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "Example": ""
    }
};
